import { MyBookingsHook } from "@models";
import { useStore } from "@stores";
import dayjs from "dayjs";

import { useEffect } from "react";

export const useMyPastBookings = (): MyBookingsHook => {
  const { bookingStore } = useStore();
  const {
    myPastBookingsLoading,
    myPastBookings,
    myPastBookingsSkipCount,
    myPastBookingsMaxResultCount,
    myPastBookingsTotalCount,
  } = bookingStore;

  useEffect(() => {
    bookingStore.getMyPastBookings({
      past: true,
      date: dayjs().format(),
      skipCount: myPastBookingsSkipCount,
      maxResultCount: myPastBookingsMaxResultCount,
    });
    return () => {
      if (window.location.pathname === "/my-bookings") return;
      bookingStore.clearMyPastBookings();
      bookingStore.setMyPastBookingsSkipCount(0);
    };
  }, [bookingStore, myPastBookingsSkipCount, myPastBookingsMaxResultCount]);

  const loadMore = () => {
    bookingStore.setMyPastBookingsSkipCount(
      myPastBookingsSkipCount + myPastBookingsMaxResultCount
    );
  };

  return {
    dataSource: Array.from(myPastBookings.values()),
    loading: myPastBookingsLoading,
    totalCount: myPastBookingsTotalCount,
    maxResultCount: myPastBookingsMaxResultCount,
    loadMore,
  };
};
